import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  adjustIcon: {
    '&:before': {
      color: '#000'
    }
  },
  outline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    borderTop: '1px solid #e8e8f1'
  },
  inputsRange: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: 20,
    justifyContent: 'space-around'
  },
  name: {
    float: 'left',
    fontSize: 12,
    color: '#16191d',
    opacity: 0.7,
    marginLeft: 22,
    marginBottom: -1
  },

  currentInputRange: {
    position: 'relative',
    borderRadius: 8,
    cursor: 'pointer',
    '-webkit-appearance': 'none',
    height: 1,
    outline: 'none',
    marginRight: 8,
    width: '100%',
    zIndex: '1',
    '&::-webkit-slider-thumb': {
      '-webkit-appearance': 'none',
      appearance: 'none',
      width: 11.2,
      height: 11.2,
      cursor: 'pointer',
      borderRadius: 2.1,
      background: 'white',
      border: '1px solid black'
    },
    '&::-moz-range-thumb': {
      '-webkit-appearance': 'none',
      appearance: 'none',
      width: 12,
      height: 12,
      cursor: 'pointer',
      borderRadius: 2.1,
      background: 'white',
      border: '1px solid black'
    },
    '&::-moz-focus-outer': {
      border: 'none'
    }
  },
  rangeWrap: {
    position: 'relative',
    marginRight: '8px',
    width: '246px',
    '&::before, &::after': {
      content: "''",
      display: 'block',
      height: '1px',
      position: 'absolute',
      top: '50%',
      left: '0',
      right: '0',
      opacity: '0.7',
      transform: 'translateY(-50%)'
    },
    '&::before': {
      background: '#000',
      width: 'var(--progressValue)',
      zIndex: '1'
    },
    '&::after': {
      background: '#babcc5'
    }
  },
  inputVisible: {
    width: 58,
    height: 40,
    border: '1px solid #DCDDE9',
    borderRadius: 8,
    marginBottom: 12,
    textAlign: 'center',
    '&:hover': {
      border: '1px solid #282B36'
    }
  },
  settingNameOutput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: 12
  }
}));

export default useStyles;
